var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.3448,
    cy: 39.4729,
    rx: 38.8243,
    ry: 38.8243,
    fill: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0731 26.5334H25.6689C24.458 26.5347 23.297 27.0164 22.4407 27.8726C21.5845 28.7289 21.1029 29.8899 21.1016 31.1008V50.6752C21.1029 51.8861 21.5845 53.0471 22.4407 53.9034C23.297 54.7597 24.458 55.2413 25.6689 55.2426H53.0731C54.284 55.2413 55.445 54.7597 56.3013 53.9034C57.1575 53.0471 57.6392 51.8861 57.6404 50.6752V31.1008C57.6392 29.8899 57.1575 28.7289 56.3013 27.8726C55.445 27.0164 54.284 26.5347 53.0731 26.5334ZM51.9166 34.0884L40.1719 43.2231C39.9429 43.4011 39.6611 43.4978 39.371 43.4978C39.0809 43.4978 38.7991 43.4011 38.5701 43.2231L26.8254 34.0884C26.6875 33.9841 26.5716 33.8536 26.4845 33.7042C26.3974 33.5548 26.3409 33.3896 26.3182 33.2182C26.2955 33.0467 26.3071 32.8725 26.3523 32.7056C26.3976 32.5387 26.4755 32.3825 26.5817 32.246C26.6878 32.1095 26.82 31.9954 26.9706 31.9104C27.1212 31.8255 27.2872 31.7713 27.4589 31.751C27.6306 31.7307 27.8047 31.7448 27.9709 31.7924C28.1372 31.84 28.2923 31.9201 28.4273 32.0281L39.371 40.5397L50.3147 32.0281C50.5884 31.8215 50.9324 31.7309 51.2723 31.7758C51.6123 31.8208 51.9209 31.9978 52.1314 32.2685C52.3418 32.5392 52.4373 32.8819 52.3971 33.2225C52.3569 33.563 52.1843 33.8741 51.9166 34.0884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e0b9cfecc6b184cabc127ff37dfd7ea6.svg";
export { ForwardRef as ReactComponent };